import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/storage';

import config from './firebaseConfig';

const app = firebase.initializeApp(config);
const auth = firebase.auth();
const storage = firebase.storage();
const db = app.firestore();
// eslint-disable-next-line
if (location.hostname === 'localhost' && false) {
  db.settings({
    host: 'localhost:9000',
    ssl: false,
  });
}
const functions = firebase.functions();
export {
  app,
  auth,
  firebase,
  functions,
  db,
  storage,
};
